import { useTranslation } from "react-i18next";

export const useGetTitle = (title?: string) => {
  const { t } = useTranslation();

  return title ?? t("portal:cockpit.managementTile.subscription.title");
};
